import { Autocomplete, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IEnseignantItem } from "../../store/focusEcoleSlice";


export interface ISearchBarByEtabProps {
  localArraySouscripteur: any;
  setLocalArraySouscripteur: (x: any) => void;
  currentEtab: any
  setCurrentEtab: any
}

const SearchBarByEtab = (props: ISearchBarByEtabProps) => {

  const { localArraySouscripteur, setLocalArraySouscripteur, currentEtab, setCurrentEtab } = props

  const dispatch = useDispatch();
  const { etabs } = useSelector((state: IReduxState) => state.focusEcole);

  return (
    <Box>
      <Autocomplete
        fullWidth
        onChange={(e: any, et: any) => {
          if (et) {
            setCurrentEtab({
              ...currentEtab,
              codeEtab: et.codeEtab
            });
          }
          else {
            setCurrentEtab({})
            setLocalArraySouscripteur([...localArraySouscripteur])
          }
        }}
        options={etabs}
        renderOption={(props, e) => {
          const { libEtab, codeEtab } = e;
          const newIndex = etabs.findIndex((item: any) => item.codeEtab === codeEtab)
          return (
            <span {...props}
              style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
            >
              {libEtab}
            </span>
          );
        }}

        getOptionLabel={(etab) =>
          `${etab.libEtab} ${etab.codeEtab}`
        }

        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            size="small"
            label="Choisir un établissement"
          />
        )}
      />
    </Box>
  );
};
export default SearchBarByEtab;
